import React, { useCallback, useEffect, useState } from "react";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";

const SUPABASE_URL = () => globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL;
const REFRESH_INTERVAL_MS = 60000;

function StatCard({ label, value, detail, accent, detailClassName }) {
  return (
    <div
      className="card h-100"
      style={{
        borderLeft: `4px solid ${accent}`,
      }}
    >
      <div className="card-body py-3">
        <div className="text-muted small">{label}</div>
        <div className="fs-3 fw-bold">{value}</div>
        {detail && <div className={`small ${detailClassName || "text-muted"}`}>{detail}</div>}
      </div>
    </div>
  );
}

function DashboardStats({ onStatsLoaded, refreshTrigger }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      const headers = {
        ...authenticatedHeadersHash(),
        "Content-Type": "application/json",
        "Content-Profile": globalThis.Qwoted.POSTGREST_API_SCHEMA,
      };

      const res = await fetch(`${SUPABASE_URL()}/rest/v1/rpc/admin_request_dashboard_stats`, {
        method: "POST",
        headers,
        body: "{}",
      });

      if (res.ok) {
        const data = await res.json();
        setStats(data);
        if (onStatsLoaded) onStatsLoaded(data);
      }
    } finally {
      setLoading(false);
    }
  }, [onStatsLoaded]);

  // Fetch on mount, on refreshTrigger change, and on interval
  useEffect(() => {
    fetchStats();
    const interval = setInterval(fetchStats, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [fetchStats, refreshTrigger]);

  if (loading && !stats) {
    return (
      <div className="row g-3 mb-4">
        {[1, 2, 3].map((idx) => (
          <div key={idx} className="col-md-4">
            <div className="card h-100">
              <div className="card-body py-3">
                <div className="placeholder-glow">
                  <span className="placeholder col-6" />
                  <span className="placeholder col-4 fs-3" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!stats) return null;

  const oldestMinutes = stats.oldest_pending_minutes;
  const oldestDetail = oldestMinutes != null ? `oldest: ${oldestMinutes}m ago` : null;
  const oldestDanger = oldestMinutes != null && oldestMinutes > 60;

  return (
    <div className="row g-3 mb-4">
      <div className="col-md-4">
        <StatCard
          label="Automation Rate"
          value={`${stats.automation_rate || 0}%`}
          detail={`${stats.auto_processed_today || 0} of ${stats.total_today || 0} today`}
          accent="#198754"
        />
      </div>
      <div className="col-md-4">
        <StatCard
          label="Manual Queue"
          value={`${stats.manual_queue_depth || 0} pending`}
          detail={oldestDetail}
          detailClassName={oldestDanger ? "text-danger fw-bold" : "text-muted"}
          accent="#0d6efd"
        />
      </div>
      <div className="col-md-4">
        <StatCard
          label="New Media Today"
          value={stats.new_media_today || 0}
          detail="first-time requesters"
          accent="#6f42c1"
        />
      </div>
    </div>
  );
}

export default DashboardStats;
